module.exports = __webpack_public_path__ + "static/vueminder_1-eba03d2caea8f8fc42efb277bcc7533e.png";